import React from 'react';
import Udesk from 'Udesk';
// import { getCurrentRouteName } from 'Udesk/system/subApp';

class SoundtrackManageIndexComponent extends React.Component {
    //#region Default Props
    static propTypes = {};
    static defaultProps = {};
    //#endregion

    state = {};
    privates = {
        storages: {
            selectedFilter: {
                conditionList: [],
                customJudgeLogic: null,
                judgeStrategy: Udesk.enums.operatorRuleTypes.all.id,
            },
        },
        filterVisible: false,
        isUpdate: false,
        filterManageRef: React.createRef(),
    };
    enableStorage = false;
    storageStrategies = {
        storageWay: 'sessionStorage',
        extraStorages: [],
        resetStrategies: {
            transitionToRoutes: [],
            notTransitionToRoutes: [],
        },
    };

    actions = {
        onPageChanged(pageNum, pageSize, total) {
            this.trigger('onPageChanged', pageNum, pageSize, total);
        },
        editFilter(filter) {
            this.actions.onSelectedFilterChanged(filter);
            this.privates.filterVisible = true;
            this.actions.update();
        },
        onEditFilterVisibleChanged(visible) {
            this.privates.filterVisible = visible;
            this.actions.update();
        },
        // onViewItemDetail(item, selectedFilter) {
        //     this.trigger('onSelectedDatumChanged', item);
        //     this.trigger('onSelectedFilterChanged', selectedFilter);
        //     let routeOptions = {
        //         history: this.props.history,
        //         routeName: getCurrentRouteName('eCommentManageDetail'),
        //         pathParams: {
        //             id: item.dataId,
        //         },
        //     };
        //     Udesk.ui.routing.transitionTo(routeOptions);
        // },
        onSelectedFilterChanged(filter) {
            if (filter) {
                let conditionList = Udesk.utils.object.deepCopy(filter.conditionList);
                if (conditionList && conditionList instanceof Array && conditionList.length > 0) {
                    conditionList = conditionList.map((condition) => {
                        if (condition.field && condition.field.id) {
                            condition.field = condition.field.id;
                        }
                        return condition;
                    });
                }
                filter.displayConditionList = conditionList;
                this.privates.storages.selectedFilter = filter;
            } else {
                this.privates.storages.selectedFilter = {
                    conditionList: [],
                    customJudgeLogic: null,
                    judgeStrategy: 1,
                };
            }
            this.trigger('onSelectedFilterChanged', this.privates.storages.selectedFilter);
            this.actions.update();
        },
        onConditionFilterSaved(value, data) {
            this.privates.isUpdate = !this.privates.isUpdate;
            if (data) {
                // this.actions.onSelectedFilterChanged(data);
                let changeSelectFilter =
                    this.privates.filterManageRef.current.actions.changeSelectFilter;
                changeSelectFilter && changeSelectFilter(data);
            }
            this.actions.update();
        },
    };

    //#region Life Cycle
    init() {
        let defaultSearchTemplate = this.props.sdkOptions.props.defaultSearchTemplate.find(
            (template) => `${template.templateType}` === Udesk.enums.filterTypes.soundtrackManage.id
        );
        if (defaultSearchTemplate) {
            this.privates.storages.selectedFilter = defaultSearchTemplate;
        }
        let transitionParams = JSON.parse(localStorage.getItem('maualAddToManage_pamars'));

        if (transitionParams != null) {
            this.privates.storages.selectedFilter = transitionParams;
        }
    }

    parseProps({ props, prevProps }) {
        const queryParams = new URLSearchParams(props.location.search);
        let isNewTab = queryParams.get('newTab');
        if (isNewTab) {
            let keyword = queryParams.get('keyword');
            this.privates.keyword = keyword;
        }
    }
    componentDidMount() { }
    componentWillUnmount() { }

    //#endregion
}

export default SoundtrackManageIndexComponent;
